export function downloadFile(url: string, fileName?: string) {
  const tempLink = document.createElement('a')
  tempLink.style.display = 'none'
  tempLink.href = url
  tempLink.setAttribute('download', fileName ?? 'file')
  if (typeof tempLink.download === 'undefined') {
    tempLink.setAttribute('target', '_blank')
  }
  document.body.appendChild(tempLink)
  tempLink.click()
  document.body.removeChild(tempLink)
}

export function openFileUrl(url: string) {
  window.open(url, '_blank')
}

export function downloadBlobData(data: string | Blob, fileName?: string) {
  const blob = new Blob([data])
  const blobUrl = window.URL.createObjectURL(blob)
  downloadFile(blobUrl, fileName)
}

export function openBlobData(data: string | Blob) {
  const blob = new Blob([data], { type: 'application/pdf' })
  const blobUrl = window.URL.createObjectURL(blob)
  openFileUrl(blobUrl)
}


